const SALE_TYPES = {
    1: "Cash deal",
    2: "Wholesale",
    3: "Outside",
    4: "BHPH"
}

const TAX_METHODS = {
    'DEFERRED': 'Tax Deferred',
    'PAID': 'Tax Paid (advanced)'
}

const TAX_TYPES = [
    {
        value: 'MV',
        description: 'MV - Motor Vehicle Sale '
    },
    {
        value: 'FL',
        description: 'FL - Fleet Sale'
    },
    {
        value: 'DL',
        description: 'DL - Dealer Sale'
    },
    {
        value: 'SS',
        description: 'SS - Subsequent Sale'
    }
]

const PAYMENT_CYCLES = [
    "Monthly",
    "Semi-Monthly",
    "Weekly",
    "Bi-Weekly"
]

const PAYMENT_CYCLE_OPTIONS = {
    'Monthly': 'Monthly',
    'Semimonthly': 'Semi-monthly',
    'Weekly': 'Weekly',
    'Biweekly': 'Biweekly'
}

const RETAIL_TRANS_TYPE = 'Retail'

const BHPH_FINANCE_TYPE = 'BHPH'

const TRADE_IN = "Trade-In"

/** The maximum number of co-buyers for a sale. */
const MAX_SALE_COBUYERS = 2

/** The maximum number of co-signors for a sale. */
const MAX_SALE_COSIGNORS = 2

/** The amount of time to wait while the user is typing before we send a save request to the backend API. */
const SAVE_DEBOUNCE_MILLIS = 501

/**  */
const ITEMIZED_FEE_CATEGORIES = ['inventory tax', 'title', 'registration', 'state inspection fee (full inspection)', 'other', 'plate', 'inspection']

module.exports = {
    SALE_TYPES,
    TAX_METHODS,
    TAX_TYPES,
    PAYMENT_CYCLES,
    PAYMENT_CYCLE_OPTIONS,
    MAX_SALE_COBUYERS,
    MAX_SALE_COSIGNORS,
    SAVE_DEBOUNCE_MILLIS,
    RETAIL_TRANS_TYPE,
    BHPH_FINANCE_TYPE,
    TRADE_IN,
    ITEMIZED_FEE_CATEGORIES
}
